import ElfsightGoogleReviews from '@/components/shared/elfsight-google-reviews';
import Adaptative from '@/features/home/adaptative';
import Advantage from '@/features/home/advantage';
import Clients from '@/features/home/clients';
import Features from '@/features/home/features';
import Hero from '@/features/home/hero';
import Infos from '@/features/home/infos';
import Pricing from '@/features/home/pricing';
import Testimonials from '@/features/home/testimonials';
import { Fragment } from 'react';

export default function Page() {
  return (
    <Fragment>
      <Hero />
      <div className="max-width-blue-section flex flex-col gap-4">
        <p className="text-2xl">La solution la mieux notée par vos confrères</p>
        <ElfsightGoogleReviews />
      </div>
      <Advantage />
      <Adaptative />
      <Features />
      <Infos />
      <Testimonials />
      <Clients />
      <Pricing />
    </Fragment>
  );
}
